import { gql, useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import React from "react";
import { AvailableUsersContext } from "./AvailableUsersContext.js";
import {
  AvailableUsersQuery,
  useAvailableUsersQuery,
} from "./AvailableUsersProvider.generated.js";
import { useAuth } from "./useAuth.js";

export const AvailableUsersProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const { isAuthenticated } = useAuth();

  const { availableUsers, isLoading, refetch } = useAvailableUsers({
    skip: !isAuthenticated,
  });

  return (
    <AvailableUsersContext.Provider
      value={{ availableUsers, isLoading, refetch }}
    >
      {children}
    </AvailableUsersContext.Provider>
  );
};

const EMPTY_ARRAY: Extract<
  AvailableUsersQuery["availableUsers"],
  { __typename: "AvailableUsersResult" }
>["availableUsers"] = [];
function useAvailableUsers({ skip }: { skip: boolean }) {
  const client = useApolloClient();
  const query = useAvailableUsersQuery({ client, skip });

  const availableUsers =
    getDataOrNull(query.data?.availableUsers)?.availableUsers ?? EMPTY_ARRAY;

  return {
    availableUsers,
    isLoading: query.loading,
    refetch: query.refetch,
  };
}
